import React from 'react';
import PropTypes from 'prop-types';
/** using glu theming here since this will bring in styles for  */
import { withStyles } from 'theme/withStyles';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Offer from 'containers/Offer';
import { pick } from 'lodash';
import dataActions from 'core/data/actions';

import { CheckmarkBase as Checkmark } from './components/Checkmark';
import Content from './components/Content';

const styles = ({ palette, spacing }) => ({
  bundleOffer: {
    '& h3': {
      margin: 0,
    },
    '&:last-child': {
      border: 'none',
      paddingBottom: 0,
    },
    borderBottom: `1px solid ${palette.form.border}`,
    padding: [11, 0],
    position: 'relative',
  },
  description: {
    marginBottom: 8,
    textAlign: 'center',
  },
  root: {
    background: palette.background,
    border: `1px solid ${palette.grey.light}`,
    borderRadius: spacing.unit,
    margin: [0, 'auto'],
    marginBottom: spacing.md,
    maxWidth: 440,
    padding: [11, 20, 18, 10],
    position: 'relative',
  },
});

const Bundle = ({
  bundleOffers,
  changeData,
  checked,
  classes,
  description,
  hasRealBundles,
  isPrimary,
  label,
  name,
  offers,
  type,
}) => {
  if (type === 'SELECT_ALL') {
    return (
      <>
        <p className={classnames(classes.description, 'bundle-description')}>{description}</p>
        <div className={classnames(classes.root, 'bundle')}>
          <Checkmark
            label={label}
            checked={checked}
            onClick={(newVal) => {
              Object.entries(bundleOffers).forEach(([, offer]) => {
                changeData(offer.fieldChosen, newVal);
              });
            }}
            name={name}
            id={`bundle-${name}`}
            isDisabled={isPrimary}
          />
          <Content fieldChosen={name}>
            {offers.map((o) => (
              <div className={classnames('bundle-offer', 'offer', classes.bundleOffer)} key={o}>
                <Offer key={o} offerName={o} isInAllBundle />
              </div>
            ))}
          </Content>
        </div>
      </>
    );
  }

  if (!hasRealBundles) {
    return offers.map((o) => <Offer key={o} offerName={o} />);
  }

  return (
    <div className={classnames('bundle')}>
      <p className={classnames(classes.description, 'bundle-description')}>{description}</p>
      {offers.map((o) => (
        <Offer key={o} offerName={o} />
      ))}
    </div>
  );
};

Bundle.propTypes = {
  bundleOffers: PropTypes.shape({}).isRequired,
  changeData: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  description: PropTypes.string,
  hasRealBundles: PropTypes.bool,
  isPrimary: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  offers: PropTypes.arrayOf(PropTypes.string).isRequired,
  type: PropTypes.string.isRequired,
};

Bundle.defaultProps = {
  description: '',
  hasRealBundles: true,
  isPrimary: false,
  label: undefined,
};

const BundleStyled = withStyles(styles)(Bundle);

const mapStateToProps = ({ bundles, data, offers }, { name }) => {
  const bundle = bundles[name];
  const bundleOffers = pick(offers, bundle.offers);
  const checked =
    Object.entries(bundleOffers).filter(([, offer]) => data[offer.fieldChosen]).length ===
    bundle.offers?.length;
  return { bundleOffers, checked };
};

export default connect(mapStateToProps, { changeData: dataActions.changeData })(BundleStyled);
